/** DOM id of an evidence slot card, so a refused submit can scroll to the first short one. */
export function evidenceSlotAnchorId(slotId: string): string {
  return `evidence-slot-${slotId}`
}
